import React from "react";
import "./TextField.css";

function TextField({ error, focus, onChange, name, value, placeholder , style}) {
  return (
    <div className="custom-text-filed"  style={style}>
      <input
     
        placeholder={placeholder}
        autoFocus={focus}
        onChange={onChange}
        name={name}
        type="text"
        value={value}
      />

     {!!error && <div className="error font12 color_crimson proxima_regular">{error}</div>}
    </div>
  );
}

export default TextField;
